import { all, fork, put, takeEvery } from 'redux-saga/effects';
import {
	GridSettingsHelper,
	initializeUITourManagerTransaction,
	MessageBox,
	MessageBoxButtons
} from '../../..';
import { ServiceList } from '../../../services/serviceList';
import {
	getUserDetailAction,
	getUserSettingParametersAction,
	getUserSettingPermissionsAction,
	setMFAProperties,
	setUserProfileImageAction
} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import { IGetUserDetailResponse } from '../entities/GetUserDetailResponse';
import { IGetUserSettingParametersResponse } from '../entities/GetUserSettingParametersResponse';
import { IGetUserSettingPermissionsResponse } from '../entities/GetUserSettingPermissionsResponse';
import { mobile } from '@bimser/core';
import { removeAuth } from '../../../utilities/removeAuth';
import { findMessage } from '@bimser/components';

export default function* watchGetUserStartupTransaction() {
	yield all([
		takeEvery(ActionTypes.GET_USER_STARTUP_TRANSACTION, getUserStartupTransaction),
		takeEvery(ActionTypes.USER_PASSIVED, userPassived)
	]);
}

export function* getUserStartupTransaction() {
	yield put(initializeUITourManagerTransaction());
	yield fork(getUserDetailData);
	yield fork(getUserSettingPermissions);
	yield fork(getGridSettings);
}

function* userPassived() {
	yield MessageBox.error({
		title: findMessage.get('100926'),
		content: findMessage.get('103615'),
		buttons: MessageBoxButtons.OK
	});

	removeAuth(false);
}

function* getUserDetailData() {
	try {
		if (!mobile().any()) {
			navigator.geolocation.getCurrentPosition(loc => {
				(window as any).geoLocation = {
					lat: loc.coords.latitude,
					lon: loc.coords.longitude
				};
			});
		}

		const isRedirect = window.location.hash.includes('_redirect');
		let canGetUserDetails = true;
		if (isRedirect) {
			const redirectDataStr = sessionStorage.getItem('redirectData') || '{}';
			const redirectData = JSON.parse(redirectDataStr);

			if (redirectData.type != 'OpenMainPage') {
				canGetUserDetails = false;
			}
		}

		if (!canGetUserDetails) {
			return;
		}

		const response: IGetUserDetailResponse = yield ServiceList.hr.Users.GetUserDetail.call();

		sessionStorage.setItem(
			'theme',
			JSON.stringify({
				backgroundColor: response.info.themeData?.backgroundColor,
				primaryColor: response.info.themeData?.primaryColor,
				image: response.info.themeData?.image
			})
		);
		window.dispatchEvent(new Event('themeLoaded'));
		yield put(getUserDetailAction(response));

		if (logoutUnauthorizedIDEUser(response.canNavigateIDE, response.canNavigateWEB)) {
			return null;
		}

		yield put(
			setMFAProperties({
				mfaEnabled: response.info.mfaEnabled,
				authenticatorEnabled: response.info.authenticatorEnabled
			})
		);
		yield put(
			getUserSettingParametersAction({
				notificationSoundStatus: response.notificationSoundStatus
			})
		);

		const data: string =
			(window as any).serviceConfig.services.login.baseURL + response.info.profileImage;
		yield put(setUserProfileImageAction(data));
	} catch (error) {
		console.log('error', error);
	}
}

function logoutUnauthorizedIDEUser(canNavigateIDE: boolean, canNavigateWEB: boolean) {
	const { pathname } = window.location;
	let logout = false;
	if (pathname === '/ide/' && !canNavigateIDE) {
		logout = true;
	} else if (pathname === '/' && !canNavigateWEB) {
		logout = true;
	}

	if (logout) {
		localStorage.removeItem('token');
		sessionStorage.removeItem('token');
		window.location.pathname = '/';
	}
	return logout;
}

function* getGridSettings() {
	try {
		const response = yield ServiceList.web.GridSettings.GetGridStoreSettings.call();

		if (response) GridSettingsHelper.setCacheSettings(response);
		else GridSettingsHelper.setCacheSettings(null);
	} catch (error) {
		GridSettingsHelper.setCacheSettings(null);
		console.log('error', error);
	}
}

function* getUserSettingPermissions() {
	try {
		const isRedirect = window.location.hash.includes('_redirect');
		if (isRedirect) {
			return;
		}
		const response: IGetUserSettingPermissionsResponse =
			yield ServiceList.hr.UserSettings.GetUserSettingPermissions.call();
		yield put(getUserSettingPermissionsAction(response));
	} catch (error) {
		console.log('error', error);
	}
}

export function* getUserSettingParameters() {
	try {
		const response: IGetUserSettingParametersResponse =
			yield ServiceList.hr.UserSettings.GetUserSettingParameters.call();
		yield put(getUserSettingParametersAction(response));
	} catch (error) {
		console.log('error', error);
	}
}

export function* GetUserProfileImageDownloadUrl() {
	try {
		const response: string = yield ServiceList.hr.Users.GetUserProfileImageDownloadUrl.call();

		const data: string = (window as any).serviceConfig.services.login.baseURL + response;

		yield put(setUserProfileImageAction(data));
	} catch (error) {
		console.log('error', error);
	}
}
